<template>
  <el-dialog
      ref="dialogExRef"
      :visible="visible"
      :title="title"
      :fullscreen="isFullScreenVal"
      :show-close="false"
      :show="show"
      :close-on-click-modal="true"
  >
    <template #title>
      <div class="img-dialog__header">
          <span class="el-dialog__title">
          <span class="img-dialog__title"></span>
            {{title}}
          </span>
        <div class="img-dialog__icon">
          <i
              title="放大"
              :class="isFullScreenVal ? 'iconfont icon-fullscreen-shrink' : 'iconfont icon-fullscreen-expand'"
              style="font-size: 24px"
              @click="fullScreenDialog"
          ></i>
          <i
              title="关闭"
              class="iconfont icon-close"
              style="font-size: 24px"
              @click="closeDialog"
          ></i>
        </div>
      </div>
    </template>
    <slot name="body">
    </slot>
    <slot name="footer" v-if="false" class="dialogFooter">
    </slot>
  </el-dialog>
</template>

<script>

export default {
  name: "dialogEx",
  data() {
    return {
      isFullScreenVal: this.isFullscreen, // 全屏
      visible: this.show// 隐藏弹窗
    }
  },
  props: {
    show: {type: Boolean, default: false},
    title: {type: String, default: ''},
    isFooter: {type: Boolean, default: false},
    isFullscreen:{type: Boolean, default: false}
  },
  setup (props, { emit }) {
    console.log(props)

    const closeDialog = () => {
      emit("closeMsg")
    }

    return {
      closeDialog
    }
  },
  // watch : {
  //   isFullscreen(value) {
  //     let that = this
  //     const el = that.$refs.dialogExRef
  //     if (value) {
  //       el.style.marginTop = "0px"
  //       el.style.marginLeft = "0px"
  //     }
  //   }
  // },
  methods: {
    fullScreenDialog() {
      let that = this
      that.isFullScreenVal = !that.isFullScreenVal
      const el = that.$refs.dialogExRef
      if (that.isFullScreenVal) {
        el.style.top = 0
        el.style.left = 0
        el.style.width = "100VW"
        el.style.height = "100VH"
        el.style.marginTop = 0;
      }
    },
  },
}
</script>

<style scoped>
.img-dialog__header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.el-dialog__title {
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  word-wrap: break-word;
}

.img-dialog__title {
  display:inline-block;
  background-color: #3478f5;
  width:3px;
  height:20px;
  margin-right:5px;
  float: left;
  margin-top:2px;
}

.img-dialog__icon {
  float: left;
}

.img-dialog__icon i {
  color: #909399;
  font-size: 15px;
  cursor: pointer;
}

.img-dialog__icon i:hover {
  color: #409eff;
  cursor: hand;
}

.dialogFooter {
  position: absolute;
  bottom: 0;
}
</style>